module.exports = __webpack_public_path__ + "img/Logo-AEJ.526854e0.png";